export const PRODUCT_EVENT_NAMES = new Set([
  "cta_clicked",
  "activation_viewed",
  "activation_key_created",
  "activation_integration_copied",
  "activation_request_started",
  "activation_request_completed",
  "activation_request_failed",
  "signup_started",
  "signin_started",
  "auth_completed",
  "api_key_create_started",
  "api_key_created",
  "api_key_create_failed",
  "mcp_key_create_started",
  "mcp_key_created",
  "mcp_key_create_failed",
  "billing_viewed",
  "checkout_started",
  "feedback_opened",
  "feedback_submitted",
  "feedback_submit_failed",
]);

// Technical telemetry is intentionally separate from product milestones so it
// cannot be accidentally used as an adoption or conversion funnel step.
export const DEEPFACE_SESSION_STARTED_EVENT = "deepface_session_started";
export const TELEMETRY_EVENT_NAMES = new Set([DEEPFACE_SESSION_STARTED_EVENT]);
